import React from "react";
const Image = (props) => <img alt='image' title='image' role='img' {...props}  />

export default Image;
